import * as React from "react";
import { BackHandler } from "react-native";
function useBackButton(ref) {
  React.useEffect(function() {
    var subscription = BackHandler.addEventListener("hardwareBackPress", function() {
      var navigation = ref.current;
      if (navigation == null) {
        return false;
      }
      if (navigation.canGoBack()) {
        navigation.goBack();
        return true;
      }
      return false;
    });
    return function() {
      return subscription.remove();
    };
  }, [
    ref
  ]);
}
export {
  useBackButton
};
//# sourceMappingURL=useBackButton.native.js.map
